// extracted by mini-css-extract-plugin
module.exports = {"qr-card-downloader":"styles_qr-card-downloader__ezcAV"};